"use server";

import { getRequestContext } from "@rangojs/router";
import { CartFlash } from "../location-states.js";

export async function addToCart(formData: FormData) {
  const ctx = getRequestContext();
  const session = ctx.get("session")!;
  const commerce = ctx.get("userCommerce")!;

  const productId = formData.get("productId") as string;
  const quantity = Number(formData.get("quantity") ?? 1);

  let basketId = session.get("basketId");

  // Lazy create basket on first add
  if (!basketId) {
    try {
      const basket = await commerce.shopperBaskets.createBasket({
        parameters: { currency: undefined, locale: undefined } as any,
        body: { currency: commerce.config.currency },
      });
      basketId = basket.basketId!;
    } catch (e: any) {
      // Quota exceeded — reuse existing basket from error response
      if (e.response) {
        const body = await e.response.text();
        try {
          const err = JSON.parse(body);
          if (err.basketIds) {
            basketId = err.basketIds;
          } else {
            throw e;
          }
        } catch {
          throw e;
        }
      } else {
        throw e;
      }
    }
    session.set("basketId", basketId);
  }

  await commerce.shopperBaskets
    .addItemToBasket({
      parameters: { basketId, currency: undefined, locale: undefined } as any,
      body: [{ productId, quantity }],
    })
    .catch(async (e: any) => {
      if (e.response) {
        const body = await e.response.text();
        console.error("addItemToBasket failed:", e.response.status, body);
      }
      throw e;
    });

  ctx.setLocationState(CartFlash({ text: "Item added to basket" }));
}

export async function updateCartItem(formData: FormData) {
  const ctx = getRequestContext();
  const session = ctx.get("session")!;
  const commerce = ctx.get("userCommerce")!;

  const basketId = session.get("basketId");
  if (!basketId) return;

  const itemId = formData.get("itemId") as string;
  const quantity = Number(formData.get("quantity"));

  if (quantity <= 0) {
    await commerce.shopperBaskets.removeItemFromBasket({
      parameters: {
        basketId,
        itemId,
        currency: undefined,
        locale: undefined,
      } as any,
    });
  } else {
    await commerce.shopperBaskets.updateItemInBasket({
      parameters: {
        basketId,
        itemId,
        currency: undefined,
        locale: undefined,
      } as any,
      body: { quantity },
    });
  }
}

export async function removeFromCart(formData: FormData) {
  const ctx = getRequestContext();
  const session = ctx.get("session")!;
  const commerce = ctx.get("userCommerce")!;

  const basketId = session.get("basketId");
  if (!basketId) return;

  const itemId = formData.get("itemId") as string;

  await commerce.shopperBaskets.removeItemFromBasket({
    parameters: { basketId, itemId, currency: undefined, locale: undefined } as any,
  });
}
